import { Component, OnInit } from '@angular/core';
import { IPIndicatorData } from '../../models';
import { ApiClientService } from '../../../../../../@core/services';
import { ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'renew-achievement-indicator',
  templateUrl: './renew-achievement-indicator.component.html',
  styleUrls: ['./renew-achievement-indicator.component.scss'],
})
export class RenewAchievementIndicatorComponent implements OnInit {
  unitId: number = 0;
  criteriaId: number = 0;
  data: IPIndicatorData;
  dataLoaded: boolean = false;

  constructor(private api: ApiClientService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.unitId = +params['unitId'];
      this.criteriaId = +params['criteriaId'];
      this.getData();
    });
  }
  getData() {
    this.api.getData(`api/ImprovementPlan/Process/${this.unitId}/${this.criteriaId}`).subscribe((res: IPIndicatorData) => {
      this.data = res;
      this.dataLoaded = true;
    });
  }
}
